/**
 * Частые вопросы на посадочной странице, по-русски.
 *
 * Отдельным файлом и без единого импорта: те же вопросы попадают в разметку
 * JSON-LD, а её собирает vite.config.ts, где псевдоним «~» ещё не действует.
 * Текст на странице и текст в разметке обязаны совпадать слово в слово, иначе
 * разметка считается недостоверной, — поэтому источник у них один.
 *
 * Разметка для поисковиков всегда русская: сайт русский, и англоязычный
 * посетитель не должен менять то, что поисковик уже проиндексировал.
 */

export interface Question {
  question: string;
  answer: string;
}

export const QUESTIONS: Question[] = [
  {
    question: "Сколько стоит?",
    answer:
      "Нисколько. Платного здесь нет вообще ничего: ни подписки, ни рекламы, ни продажи данных на сторону. Это пет-проект, и исходники открыты — ссылка в самом низу страницы.",
  },
  {
    question: "Обязательно регистрироваться?",
    answer:
      "Да, нужны почта и пароль. Без учётной записи негде хранить историю партий и незачем вести таблицу лидеров. Писем мы не шлём: адрес нужен только чтобы войти.",
  },
  {
    question: "Что вы делаете с моими данными?",
    answer:
      "Храним почту, хеш пароля, имя для таблицы и результаты партий. Больше у нас про тебя ничего и нет: счётчиков на странице не стоит, cookie мы не ставим. Удалить учётную запись можно одной кнопкой, вместе со всем перечисленным.",
  },
  {
    question: "Откуда берутся места?",
    answer:
      "Из своего каталога: почти три сотни областей на всех континентах — города, побережья, горы, пустыни. Точка внутри области каждый раз выбирается заново, поэтому одна и та же Барселона то показывает порт, то незнакомый спальный район на склоне.",
  },
  {
    question: "Чем это отличается от игр с панорамами улиц?",
    answer:
      "Тем, что смотришь сверху. Ни вывесок, ни номеров машин, ни языка на указателях: читать приходится форму кварталов, рельеф, русла рек и цвет полей. Первые раунды от этого тяжелее, зато потом начинаешь замечать, что застройка у каждой части света своя.",
  },
];
